import { QueryClient } from "@tanstack/react-query";
import { UnauthorizedError } from "./api";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        retry: (count, error) =>
          !(error instanceof UnauthorizedError) && count < 1,
      },
    },
  });
}
